class UploadManagerProgressReportItem {
  public progress: number = 0;

  constructor(
    public identifier: string,
    public totalChunks: number,
    public uploadedChunks: number
  ) {
    if (totalChunks > 0) {
      this.progress = Math.floor((uploadedChunks * 100) / totalChunks);
    }
  }
}

export default UploadManagerProgressReportItem;
